module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0136.jpg?v=1a576904";